module.exports = __webpack_public_path__ + "static/img/articlefoot_img_bg_qq.9abb629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articlefoot_img_bg_qq.png
// module id = hv/s
// module chunks = 0